import { X } from "lucide-react";
import { WashBooking } from "../../../types/admin/washBookings.types";
import { useTranslation } from "react-i18next";
import { Info, Section, Services } from "../Common/CardUIHelpers";

export function BookingCard({
  booking,
  onClose,
}: {
  booking: WashBooking;
  onClose: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative mt-5 w-full max-w-5xl bg-popupLight dark:bg-popupDark rounded-2xl shadow-xl p-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700"
        >
          <X size={20} />
        </button>

        <h2 className="text-2xl font-bold mb-6">{t("Wash Booking Details")}</h2>

        <Section title={t("Customer")}>
          <Info label={t("Name")} value={booking.user?.name} />
          <Info label={t("Phone")} value={booking.user?.phone} />
          <Info label={t("Email")} value={booking.user?.email} />
        </Section>

        <Section title={t("Wash Details")}>
          <Info label={t("Package")} value={booking.package?.title} />
          <Info label={t("Date")} value={booking.date} />
          <Info label={t("Time")} value={booking.slotTime} />
          <Info label={t("City")} value={booking.city} />
          <Info
            label={t("Price")}
            value={booking.price ? `₹${booking.price}` : undefined}
          />
          <Info label={t("Status")} value={booking.status} />
        </Section>

        <Section title={t("Car")}>
          <Info
            label={t("Car")}
            value={`${booking.car?.brand || ""} ${booking.car?.model || ""}`}
          />
          <Info label={t("Number")} value={booking.car?.number} />
        </Section>

        <Section title={t("Services")}>
          <Services services={booking.package?.services} />
        </Section>
      </div>
    </div>
  );
}
